import React from 'react'
import { Link } from 'react-router-dom'
import { useContainer } from '../../hooks/useHooks/useContainer';
import { MutatingDots } from 'react-loader-spinner';

export const MyStudiesCards = () => {
    const  { items, loading }  = useContainer('/data/studies.json');
    console.log(items)
    return loading ? 
    <div className='flex justify-center items-center spinner'>
        <MutatingDots 
        height="100"
        width="100"
        color="#570DF8"
        secondaryColor= '#2F2E41'
        radius='12.5'
        ariaLabel="mutating-dots-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        />
    </div> 
    :
    <>
        <div className='flex flex-wrap flex-row justify-center items-center sm:flex-col'>
            {items && items.map(item => {
                return(
                    <div className="card w-2/5	 bg-base-100 shadow-xl border-2 border-sky-500 m-10 sm:w-4/5 md:w-3/5 xl:w-1/5 2xl:w-2/12" key={item.id}>
                        <figure className='containerImage'><img src={item.img} alt={`imagen ${item.name}`} className='object-contain w-3/5 h-3/5'/></figure>
                        <div className="card-body">
                            <h2 className="card-title">
                                {item.title}
                            </h2>
                            <h3>{item.institution}</h3>
                            <div className="h-20 xl:h-24">
                                <h4>Cursos de la carrera:</h4>
                                {item.titles.map(el => {
                                    return (
                                        <ul key={el.id} >
                                            <li>{el.name}</li>
                                        </ul>
                                    )
                                })}
                            </div>
                            <div className="card-actions justify-end">
                                {/* <Link to={`/recruiter/${item.categoria}`} className="btn btn-primary ">Ver más</Link> */}
                                <Link to={`/recruiter`} className="btn btn-primary ">Volver</Link>

                            </div>
                        </div>
                    </div>
            )
            })}
        </div>
        <div className="flex justify-center align-center pb-5">
            <Link to='/recruiter' className="btn btn-primary flex justify-self-center	 self-center w-1/5">Volver</Link>
        </div>
        </>
  
}

